import React, { useState } from 'react';
import { Shuffle } from 'lucide-react';
import excuses from '../data/excuses.json';
import LikeButton from './LikeButton';
import ShareButton from './ShareButton';

const RandomGenerator = () => {
  const [result, setResult] = useState('Click to generate!');

  const generators = [
    'Random Excuse Generator',
    'Useless Superpower Generator',
    'Weird Food Combination Generator',
    'Time-Wasting Activity Generator'
  ];

  const [currentGenerator, setCurrentGenerator] = useState(generators[0]);

  const generate = () => {
    const randomIndex = Math.floor(Math.random() * excuses.excuses.length);
    setResult(excuses.excuses[randomIndex]);
  };

  return (
    <div className="card hover-lift p-6 group">
      <div className="flex items-center space-x-2 mb-6">
        <div className="p-2 rounded-lg bg-gradient-to-br from-blue-500/20 to-cyan-500/20 group-hover:from-blue-500/30 group-hover:to-cyan-500/30 transition-colors">
          <Shuffle className="h-6 w-6 text-blue-400" />
        </div>
        <h3 className="text-xl font-semibold gradient-text">{currentGenerator}</h3>
      </div>
      <div className="bg-gradient-to-br from-blue-500/5 to-cyan-500/5 rounded-lg p-4 mb-6 min-h-[80px] flex items-center justify-center text-center">
        <p className="text-gray-300 leading-relaxed">{result}</p>
      </div>
      <div className="flex justify-between items-center">
        <div className="flex items-center space-x-2">
          <LikeButton type="excuse" content={result} />
          <ShareButton 
            title="Check out this random excuse!"
            text={result}
          />
        </div>
        <button 
          onClick={generate}
          className="text-blue-400 hover:text-blue-300 transition flex items-center space-x-1 group"
        >
          <span>Generate Another</span>
          <span className="transform group-hover:translate-x-1 transition-transform">→</span>
        </button>
      </div>
    </div>
  );
};

export default RandomGenerator;